var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBtc24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24.004,
    viewBox: "0 0 24 24.004",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 .004h24v24h-24z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.641 14.906a12 12 0 1 1 -8.741-14.546 12 12 0 0 1 8.74 14.546z",
    fill: "#f7931a",
    transform: "translate(0 -.001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1006.586 718.652c.232-1.543-.948-2.372-2.562-2.925l.524-2.09-1.278-.317-.51 2.035c-.336-.083-.681-.162-1.024-.24l.513-2.048-1.277-.317-.524 2.089c-.278-.063-.551-.125-.816-.191v-.007l-1.763-.438-.34 1.359s.948.216.928.23a.677.677 0 0 1 .6.74l-.6 2.381a1.036 1.036 0 0 1 .133.042l-.135-.033-.836 3.335a.465.465 0 0 1 -.586.3c.013.019-.929-.231-.929-.231l-.635 1.456 1.664.413c.309.077.613.158.911.234l-.529 2.114 1.277.317.524-2.091c.349.094.687.181 1.019.263l-.522 2.081 1.278.317.529-2.11c2.18.411 3.819.245 4.509-1.717a2.228 2.228 0 0 0 -1.174-3.085 2.032 2.032 0 0 0 1.632-1.868zm-2.921 4.075c-.4 1.58-3.068.726-3.934.512l.7-2.8c.867.215 3.645.641 3.232 2.289zm.4-4.1c-.36 1.437-2.585.707-3.306.528l.636-2.54c.722.179 3.045.513 2.67 2.012z",
    fill: "#fff",
    transform: "translate(-989.473 -708.323)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtc24);
export default __webpack_public_path__ + "static/media/ic_btc_24.f992927ad6d778bc91c8609e89119b7c.svg";
export { ForwardRef as ReactComponent };